module.exports = __webpack_public_path__ + "img/holiday.1859d4c9.svg";